// src/services/dashboard/AdminAuthManager.js
import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/admin`;

const AdminAuthManager = {
  async login(credentials) {
    const response = await axios.post(`${BASE_URL}/login`, credentials);
    return response.data;
  },
};

export default AdminAuthManager;
